import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import * as sha512 from 'js-sha512';

@Component({
  selector: 'app-vendor-validate',
  templateUrl: './vendor-validate.component.html',
  styleUrls: ['./vendor-validate.component.scss'],
})
export class VendorValidateComponent {

  phone; check: boolean = false;loader:boolean = false;
  otp; mobileVerify: any = {}; userId;id;numb;value;
 vendoruser:boolean=true;numCd="+91";user;
 vendoruserId;vendorMobile;url;mobileVerify1;
  constructor(private auth: AuthService,
    private service:ApiService,
              public handler: HandlerService,
              public router: Router) { }

  ngOnInit() {

  }

  sendOtp() {
    this.phone=this.numCd+this.numb;
    this.user={contactNbrMob:this.phone}
    this.service.sendForgetOtp(this.user).toPromise().then((res:any) => {
      this.check = true;
      this.handler.res('OTP Sent Successfully');
    })
    .catch(err=>{
      this.handler.err(err);
      this.check = true;
    })
  }

  validateNumber(event) {
    event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 13);
    this.phone = event.target.value
  }


  validate(event) {
    event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 6);
    this.otp = event.target.value;
    this.validMobileOtp()
  }

  onpaste(event) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    event.target.value = pastedText.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 6);
    this.otp = event.target.value;
    this.validMobileOtp()
  }

   validMobileOtp() {
      if (this.otp.length == 6) {
        if (this.otp != undefined || null) {
          var m = sha512.sha512(this.otp.toString());
        }
        this.mobileVerify = {appId:14,mobileOTP: m,contactNbrMob:this.phone }
        this.loader = true;
        this.service.validateOtp(this.mobileVerify).subscribe((res:any) => {
          localStorage.setItem('currentUserId', res.currentUser)
          localStorage.setItem('hashKey',res.hashKey)
          localStorage.setItem('organizationId',res.organizationId)
          this.handler.res('Validated Successfully !!')
          this.loader = false;
         this.router.navigate(['/newpwd']);
        },
          err => {
            this.handler.err(err);
            this.loader = false;
          })
      }
    }
    ionViewWillLeave(){
      this.phone = ""
    }
  
  }


  
  
 

  


